import { Box } from "@mui/material";
import { Element, Child } from "../../../Interface/scheduler/form";
import { useFormContext } from "../../contexts/FormContext";
import { MLY_IDS } from "../../../constants/constant";

interface WrapperElementProps {
  element: Element | Child;
  conceptCode: string;
  renderChild: (child: Child, index: number) => React.ReactNode;
}

const WrapperElement = ({
  element,
  conceptCode,
  renderChild,
}: WrapperElementProps) => {
  const { formValues } = useFormContext();
  const wrapperElement = element as Element;

  const getWrapperChild = (): Child[] => {
    if (wrapperElement?.serviceModifierEnabled) {
      return wrapperElement?.[formValues?.servicetype];
    }
    if (wrapperElement?.typeOfCleaningEnabled) {
      const type = formValues?.[MLY_IDS.SERVICE];
      const key =
        type === "residential"
          ? type + "-" + formValues?.[MLY_IDS.FREQUENCY]
          : formValues?.[MLY_IDS.COMMERCIAL_FREQUENCY];
      return wrapperElement?.[key];
    }
    return wrapperElement?.children;
  };

  const wrapperChild = getWrapperChild();

  const getBackgroundColor = () => {
    if (conceptCode === "MRE") return "background.main";
    if (conceptCode !== "MRA") return "primary.light";
    return "background.default";
  };

  return (
    <Box
      sx={{
        backgroundColor: getBackgroundColor(),
      }}
      className={element.id}
      key={element.type}
      data-testid="wrapper-element"
    >
      {wrapperChild?.map((child, index) => renderChild(child, index))}
    </Box>
  );
};

export default WrapperElement;
